/**
 * @ngdoc directive
 * @name abookApp.directive:dibsForm
 * @ DIBS - D2 - http://tech.dibspayment.com/D2
 * @description
 * # dibsForm
 */

export default function DibsLegacyDynamic() {
    return {
        template: require("./template.html"),
        scope: {
            bookingId: "<",
            amount: "<",
            bookingPeriods: "<",
            acceptUrl: "@",
            uid: "<",
        },

        controller: function (
            ENV,
            $scope,
            $location,
            paymentService,
            $timeout
        ) {
            $scope.debug = false;

            /***
             * display NETS test cards link?
             */
            $scope.isPaymentGatewayInTestMode = ENV.payment.enabled
                ? ENV.payment.gateway.purpose == "test"
                : false;

            paymentService
                .getPaymentUrl($scope.bookingId)
                .then(function (result) {
                    if (result.AlreadyPayed == true) {
                        $location.path($scope.acceptUrl);
                    } else {
                        if (result.Success) {
                            result.URL.Parameters.forEach((param, index) => {
                                if (param.Key == "accepturl") {
                                    param.Value =
                                        ENV.domain +
                                        $scope.acceptUrl +
                                        "?uid=" +
                                        $scope.uid; //  acceptUrl -> return to app
                                }

                                if (param.Key == "HTTP_COOKIE") {
                                    result.URL.Parameters.splice(index, 1);
                                }
                            });

                            /**
                             * Add test mode to projektbookbyen.dk (or other ENV with test settings )
                             */
                            if (ENV.payment.gateway.purpose == "test") {
                                result.URL.Parameters.push({
                                    Key: "test",
                                    Value: 1,
                                });
                            }

                            $scope.inputs = result.URL.Parameters;

                            //Activate the booking button!!
                            var initDibsEventListener = $scope.$on(
                                "init-dibs-payment",
                                function () {
                                    // avail parma : $events

                                    $("#DIBS_Payment_dynamic").submit();
                                }
                            );
                            $scope.$on("$destroy", initDibsEventListener);
                        } else {
                            // console.log("SERVER MESSAGE: " + result.Message);
                            $scope.apiMessage = result.Message;

                            $timeout(() => {
                                $location.path("/");
                            }, 5000);
                        }
                    }
                });
        },
    };
}
